function t(t, e, r, n, o, i, a) {
  try {
    var u = t[i](a),
        c = u.value;
  } catch (t) {
    return void r(t);
  }

  u.done ? e(c) : Promise.resolve(c).then(n, o);
}

function e(e) {
  return function () {
    var r = this,
        n = arguments;
    return new Promise(function (o, i) {
      var a = e.apply(r, n);

      function u(e) {
        t(a, o, i, u, c, "next", e);
      }

      function c(e) {
        t(a, o, i, u, c, "throw", e);
      }

      u(void 0);
    });
  };
}

function r(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}

function n(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}

function o(t, e, r) {
  return e && n(t.prototype, e), r && n(t, r), t;
}

function i(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}

function a() {
  return (a = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function u(t, e) {
  var r = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n);
  }

  return r;
}

function c(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = null != arguments[e] ? arguments[e] : {};
    e % 2 ? u(Object(r), !0).forEach(function (e) {
      i(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : u(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

function f(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), e && s(t, e);
}

function l(t) {
  return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function s(t, e) {
  return (s = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

function p(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}

function y(t, e) {
  return !e || "object" != typeof e && "function" != typeof e ? p(t) : e;
}

function b(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
    var r = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var a, u = t[Symbol.iterator](); !(n = (a = u.next()).done) && (r.push(a.value), !e || r.length !== e); n = !0) {
        ;
      }
    } catch (t) {
      o = !0, i = t;
    } finally {
      try {
        n || null == u.return || u.return();
      } finally {
        if (o) throw i;
      }
    }

    return r;
  }(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}

function O(t) {
  return function (t) {
    if (Array.isArray(t)) {
      for (var e = 0, r = new Array(t.length); e < t.length; e++) {
        r[e] = t[e];
      }

      return r;
    }
  }(t) || function (t) {
    if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
  }(t) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }();
}

var h = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function d(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}

function j(t, e) {
  return t(e = {
    exports: {}
  }, e.exports), e.exports;
}

export { f as _, o as a, r as b, j as c, y as d, l as e, b as f, i as g, p as h, a as i, c as j, O as k, h as l, e as m, d as u };